import Vue from 'vue'
import App from './App.vue'
import { store } from './store'
import i18n, { localizeElement, translateLiteral } from './i18n'
import './assets/css/common.css'
import { registerCloudSyncServiceWorker } from './utils/cloudSyncService'
import { installGlobalDialogs, showAlert, showConfirm, showPrompt } from './utils/dialog'

Vue.config.productionTip = false
Vue.prototype.$store = { state: store } // Mock Vuex structure for compatibility
Vue.prototype.$alert = showAlert
Vue.prototype.$confirm = showConfirm
Vue.prototype.$prompt = showPrompt
Vue.prototype.$tl = function (source, params) {
  return translateLiteral(this.$i18n, source, params)
}

installGlobalDialogs()

Vue.mixin({
  mounted() {
    this.$nextTick(() => {
      localizeElement(this.$el, this.$i18n)
    })
  },
  updated() {
    this.$nextTick(() => {
      localizeElement(this.$el, this.$i18n)
    })
  }
})

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')

const ensureCloudSyncServiceWorker = async () => {
  try {
    await registerCloudSyncServiceWorker()
  } catch (firstError) {
    if (firstError && firstError.code === 'CLOUD_SYNC_UNSUPPORTED') {
      window.dispatchEvent(new CustomEvent('aihelp-cloud-sync-unavailable', { detail: firstError }))
      console.warn('Cloud sync service worker is unavailable:', firstError)
      return
    }

    try {
      if (document.readyState !== 'complete') {
        await new Promise((resolve) => {
          window.addEventListener('load', resolve, { once: true })
        })
      }

      await registerCloudSyncServiceWorker()
    } catch (secondError) {
      window.dispatchEvent(new CustomEvent('aihelp-cloud-sync-unavailable', { detail: secondError }))
      console.warn('Cloud sync service worker registration failed:', firstError, secondError)
    }
  }
}

ensureCloudSyncServiceWorker()
